export default __webpack_public_path__ + "static/media/male_03.63f61f4c.png";